import { SxProps } from '@mui/material';

import { themeColors } from '@/config/theme/themeColors.ts';

export const NewEmailAttachmentsLoadingIconStyles: SxProps = {
  '-moz-animation': 'spin 1s ease-in-out infinite',
  '-webkit-animation': 'spin 1s ease-in-out infinite',
  '@-moz-keyframes spin': {
    '100%': { '-moz-transform': '' },
  },
  '@-webkit-keyframes spin': {
    '100%': { '-webkit-transform': 'rotate(-360deg)' },
  },
  '@keyframes spin': {
    '100%': {
      '-webkit-transform': 'rotate(-360deg)',
      transform: 'rotate(-360deg)',
    },
  },
  animation: 'spin 1s ease-in-out infinite',
  color: themeColors.accentColor,
  width: '36px',
};
export const NewEmailAttachmentsTrashIconWrapperStyles: SxProps = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
};

export const NewEmailAttachmentsTrashIconStyles: SxProps = {
  color: themeColors.red,
};
